// src/Api/examApi.js
import { get, post, put, del  } from "./api";

// ✅ Fetch all exams
export const fetchExamData = async () => {
  try {
    const response = await get("/exam/list");
    console.log("Raw /exam/list response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching exam data:", error);
    throw error;
  }
};

// ✅ Create new exam
export const postExamData = async (examData) => {
  try {
    const data = await post("/exam", examData);
    console.log("Exam Data Posted:", data);
    return data;
  } catch (error) {
    console.error("Error posting exam data:", error);
    throw error;
  }
};

// ✅ Fetch a test by ID
export const fetchExamById = async (id) => {
  try {
    return await get(`/test/${id}`);
  } catch (error) {
    console.error("Error fetching exam by ID:", error);
    throw error;
  }
};

// ✅ Submit test answers
export const submitTestAnswers = async (payload) => {
  try {
    const data = await post("/test", payload);
    console.log("Test Submitted:", data);
    return data;
  } catch (error) {
    console.error("Error submitting test:", error);
    throw error;
  }
};

// ✅ Fetch exam details for editing
export const fetchExamDetailsById = async (id) => {
  try {
    const data = await get(`/exam/${id}`);
    console.log("Exam data edit fill:", data);
    return data;
  } catch (error) {
    console.error("Error fetching exam details by ID:", error);
    throw error;
  }
};

// ✅ Update existing exam
export const putExamData = async (updatedExamData) => {
  try {
    const data = await put("/exam", updatedExamData);
    console.log("Exam Updated Successfully:", data);
    return data;
  } catch (error) {
    console.error("Error updating exam data:", error);
    throw error;
  }
};


// ✅ Fetch all subjects
export const fetchSubjects = async () => {
  try {
    const response = await get("/subject");
    console.log("Fetched subjects:", response);
    return response;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};

export const deleteExamById = async (id) => {
  try {
    const data = await del(`/exam/${id}`);
    console.log(`Exam with ID ${id} deleted successfully:`, data);
    return data;
  } catch (error) {
    console.error(`Error deleting exam with ID ${id}:`, error);
    throw error;
  }
};

// ✅ Fetch exam attempts with filters
export const fetchExamAttemptsWithFilters = async (
  examId,
  { page = 1, limit = 10, minScore, maxScore, startDate, endDate }
) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(minScore !== undefined && { minScore }),
      ...(maxScore !== undefined && { maxScore }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
    });

    const response = await get(
      `/exam/${examId}/attempts?${queryParams.toString()}`
    );
    console.log(`Filtered attempts for Exam ID ${examId}:`, response);
    return response;
  } catch (error) {
    console.error(
      `Error fetching filtered attempts for exam ${examId}:`,
      error
    );
    throw error;
  }
};

// Optional: export all together as default
export default {
  fetchExamData,
  postExamData,
  fetchExamById,
  fetchExamDetailsById,
  submitTestAnswers,
  putExamData,
  fetchExamAttemptsWithFilters, // 👈 new function
  deleteExamById,
  fetchSubjects
};
